<!-- <div class="page-padding">
  <div class="panel">  -->
    
    <!-- <div class="parent" style="
    background-image: url(../../../Content/Images/Mainetec_BG.jpg) !important;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: 100% 100%;">
      <img class="image1" style="height: 794px;" />
      <img class="image2" style= "margin-bottom: 20%;
      margin-left: 35%;
      margin-top: 15%; height: 150px; width: auto; border-radius: 10px;box-shadow: 0px 0px 20px #888;" src="/api/Application/DealershipLogo/100"/>
    </div> -->
  
    <div class="parent" style="background-image: url(../../../Content/Images/login-bg.jpg) !important;margin-bottom: -65px;
    background-repeat: no-repeat;
    background-attachment: fixed; 
    height: 100vh;
    background-size: cover;
    background-color: #F0F4F8;">      
      <img class="image2" style= "margin-bottom: 20%;background-color: #ffffff;
      margin-left: 35%;
      margin-top: 20%; height: 150px; width: auto; border-radius: 10px;box-shadow: 0px 0px 20px #888;" src="/api/Application/DealershipLogo/100"/>
    </div>


  <!-- </div>   
</div>
   -->




